// Moved to @kenkaiiii/gg-core. Shim keeps relative imports + the
// `@kenkaiiii/ggcoder/auth` subpath export resolving unchanged.
export { AuthStorage, NotLoggedInError, readStoredBaseUrlSync } from "@kenkaiiii/gg-core";
